<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="reprintReport('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAll()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="cityList"
                label="City"
                v-model="queryParams.cityIds"
                item-text="name"
                item-value="id"
                menu-props="auto"
                multiple
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName != 'GENERAL_MANAGER'">
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Amount:</span>
              <v-chip>
                <span>{{ totalAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="saleAnalysisReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.customerCode }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.shopName }}</td>
              <td style="text-align: right">
                {{ props.item.payAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.advPaidAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.amount | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Customer Sale Analysis Report
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Customer No
              </th>
              <th style="border: 1px solid black; text-align: center">Name</th>
              <th style="border: 1px solid black; text-align: center">Shop</th>
              <th style="border: 1px solid black; text-align: center">
                Pay Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Adv Paid Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in allSaleAnalysisReportList" :key="i">
              <td style="border: 1px solid black; text-align: left">
                {{ item.customerCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.customerName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.shopName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.payAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.advPaidAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.amount | decFormat(6) }}
              </td>
            </tr>
          </tbody>
          <tr>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
              colspan="5"
            >
              Grand Total
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ grandTotalAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- Customer dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              v-model="selectedCustomerList"
              :headers="customerHeader"
              :items="activeCustomerList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="customertotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="customerpagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedCustomerList"
                    multiple
                  ></v-checkbox>
                </td>
                <td>
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phoneNo }}</td>
                <td>{{ props.item.creditLevel.name }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setCustomer">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { saleReportService } from "../../services/sale-report-service";
import { customerService } from "../../services/customer-service";
import { shopService } from "../../services/shop-service";
import { cityService } from "../../services/city-service";

export default {
  name: "SaleAnalysisReport",
  components: {},

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showCustomerListDialog: false,
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Report",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Customer Sale Analysis Report",
        disabled: true,
      },
    ],
    headers: [
      {
        text: "Customer No",
        align: "left",
        value: "customerCode",
        sortable: false,
      },
      { text: "Name", align: "left", value: "customerName", sortable: false },
      { text: "Shop", align: "left", value: "shopName", sortable: false },
      { text: "Pay Amount", value: "payAmount", sortable: false },
      { text: "Adv Paid Amount", value: "advAmount", sortable: false },
      { text: "Amount", value: "amount", sortable: false },
    ],
    customerHeader: [
      { text: "Code", align: "left", value: "code", sortable: false },
      { text: "Name", align: "left", value: "name", sortable: false },
      { text: "Email", value: "email", sortable: false },
      { text: "PhoneNo", value: "phoneNo", sortable: false },
      { text: "Credit Level", value: "creditLevel", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerIds: [],
      shopId: "",
      cityIds: [],
    },
    saleAnalysisReportList: [],
    allSaleAnalysisReportList: [],
    decimalFormat: "",
    totalAmount: 0,
    grandTotalAmount: 0,

    clonequeryParams: new Object(),
    activeCustomerList: [],
    shopList: [],
    cityList: [],
    customerQueryParams: {
      name: "",
      code: "",
      email: "",
    },
    customerpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    customertotalRows: 0,
    selectedCustomerList: [],
    customerName: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getSaleAnalysisReport();
      },
      deep: true,
    },
    customerpagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true,
    },
  },

  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    this.decimalFormat = commonService.formatdecimal();
    if (
      this.user.role.roleName == "GENERAL_MANAGER" ||
      this.user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.shopId = this.user.shopId;
    }
    this.getShopList();
    this.getAllCity();
    this.onSearch();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "sale-analysis-report",
        query: this.queryParams,
      });
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
      this.getSaleAnalysisReport();
    },

    getSaleAnalysisReport() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      saleReportService
        .getSaleAnalysisReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.saleAnalysisReportList = res.data.saleAnalysisReportList;
            this.totalAmount = res.data.totalAmount;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    showCustomers() {
      // Clean query params
      this.customerQueryParams.code = "";
      this.customerQueryParams.name = "";
      this.customerQueryParams.email = "";
      this.customerQueryParams.customerIds = [];
      this.selectedCustomerList = [];
      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },

    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
        this.showCustomerListDialog = !this.showCustomerListDialog;
      }
    },

    onSearchCustomer() {
      this.customerQueryParams.page = this.customerpagination.page;
      this.customerQueryParams.size = this.customerpagination.rowsPerPage;
      this.getActiveCustomer();
    },
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.customerpagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerpagination.page,
          this.customerpagination.rowsPerPage,
          this.customerpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.customertotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    toggleAll() {
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList = [];
      } else {
        this.selectedCustomerList = this.activeCustomerList.slice();
      }
    },
    getAllCity() {
      cityService
        .getAllCity()
        .then((res) => {
          this.cityList = res.data.cityList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.error(err);
        });
    },
    reprintReport(divName) {
      this.buttonLoading = true;
      saleReportService
        .getSaleAnalysisReportPrint(this.clonequeryParams)
        .then((res) => {
          this.allSaleAnalysisReportList = res.data.saleAnalysisReportList;
          this.grandTotalAmount = res.data.totalAmount;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    exportAll() {
      this.buttonLoading = true;
      saleReportService
        .getSaleAnalysisReportExcel(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>